export enum SortOrder {
  DESCENDING,
  ASCENDING
}
